import React from "react";
import {
  Box,
  Button,
  Chip,
  Container,
  Paper,
  Stack,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MapIcon from "@mui/icons-material/Map";
import AddIcon from "@mui/icons-material/Add";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { BodyText } from "../../../widgets/TemplatePreview";

/* ------------------------------------------------------------------ */
/*  ShowLocationMessage                                               */
/* ------------------------------------------------------------------ */
const ShowLocationMessage = ({ data, onOpen, preview = false }) => {
  const { latitude, longitude, name, address } = data;
  const mapEmbedUrl = `https://maps.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`;
  const mapLink = `https://maps.google.com/?q=${latitude},${longitude}`;

  return (
    <Container maxWidth="md">
      <Paper variant="outlined" elevation={0} sx={{ p: 2 }}>
        {/* Trigger chips */}
        {!preview && (
          <Stack direction="row" spacing={1} flexWrap="wrap" my={1}>
            {(data.triggerText || []).map((item) => (
              <Chip key={item} variant="outlined" label={item} clickable />
            ))}
          </Stack>
        )}

        {/* Map preview (iframe uses public embed URL) */}
        <Box
          component="iframe"
          src={mapEmbedUrl}
          width="100%"
          height="250"
          sx={{ border: 0, borderRadius: 1, my: 1 }}
          loading="lazy"
          title="Location preview"
        />

        {/* Location details */}
        <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
          <LocationOnIcon fontSize="small" color="action" />
          <Typography variant="subtitle1" fontWeight={500}>
            {name}
          </Typography>
        </Stack>
        <BodyText sx={{ mb: 1 }}>{address}</BodyText>

        {/* Coordinates + “Open in Maps” link */}
        <Stack direction="row" spacing={1} alignItems="center" mb={1}>
          <Typography variant="caption" color="text.secondary">
            Lat&nbsp;{latitude},&nbsp;Lng&nbsp;{longitude}
          </Typography>
          <MuiLink
            href={mapLink}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            display="flex"
            alignItems="center"
            sx={{ ml: 1 }}
          >
            <OpenInNewIcon sx={{ fontSize: 16, mr: 0.5 }} />
            Open in Maps
          </MuiLink>
        </Stack>

        {/* “Add trigger” action */}
        <Stack direction="row" justifyContent="end">
          <Button
            onClick={() => onOpen?.()}
            startIcon={<AddIcon />}
            variant="outlined"
            size="small"
          >
            Add trigger
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default ShowLocationMessage;
